import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { Transform } from './Transform';
import { ITransformOptions } from '../../models/query/transforms';

export class MapTransform extends BaseTransform {
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		const response: any[] = [];
		const { mapTransformOptions = {} } = this.options;
		const { transforms } = mapTransformOptions;
		if (Array.isArray(queryResponse) && transforms && transforms.length > 0) {
			queryResponse.forEach((queryResponseItem) => {
				const finalValue = this.applyTransforms(queryResponseItem, transforms, queryOptions, executionOptions);
				response.push(finalValue);
			});
		}
		return response;
	}
	applyTransforms = (value: any, transforms: ITransformOptions[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions) => {
		if (transforms) {
			for (const transformOptions of transforms) {
				const transform = new Transform(transformOptions, this.translationHelper, this.callStackLevel);
				value = transform.execute(value, queryOptions, { ...executionOptions, responseContext: value });
			}
		}
		return value;
	}
}